module.exports = __webpack_public_path__ + "img/Goldvo.376264f1.png";